import React, { useState, useEffect } from "react";
// components
import { MDBDataTable } from "mdbreact";
import CustomGreenButton from "../../components/shared/custom-green-button";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import Button from "@material-ui/core/Button";
import Skeleton from "@material-ui/lab/Skeleton";
import TableColumnDropdown from "../../components/shared/table-column-dropdown/table-column-dropdown";
import swal from "sweetalert";
// icons
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import PowerSettingsNewIcon from "@material-ui/icons/PowerSettingsNew";
import AssignmentIcon from "@material-ui/icons/Assignment";
// utils
import exportFromJSON from "export-from-json";
import { GENERAL_URL_API } from "../../shared/urls";
import ExcelWorkBook from "../../components/shared/ExcelWorkBook";
import { columnasBanners } from "../../shared/data/columnas/classics/banners/columnas-banners";
import CrearBannerIndividual from "./crear-banner";
import AsignarBanner from "./asignar-banner";

const BannersTable = ({ banners, loading, onBannerUpdate }) => {
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const [editingBanner, setEditingBanner] = useState(null);
  const [assigningBanner, setAssigningBanner] = useState(null);

  // Definir las columnas de la tabla basándose en la definición importada
  const columnDefinitions = columnasBanners.map(col => ({
    ...col,
    width: col.field === "acciones" ? 200 : 150,
  }));

  const renderActionButtons = (banner) => {
    const isActive = banner.activo === "1";
    const isPersonalizado = banner.alcance === "Personalizado";

    return (
      <div className="d-flex">
        <button
          style={{
            border: "none",
            padding: "3px 8px",
            backgroundColor: "#5fbeaa",
            fontWeight: "500",
            color: "#fff",
            borderRadius: "3px",
            fontSize: "0.85em",
            marginRight: "5px",
          }}
          onClick={() => handleEdit(banner)}
          size="small"
        >
          <EditIcon style={{ fontSize: "14px", marginRight: "3px" }} />
          Editar
        </button>

        {isPersonalizado ? (
          <button
            style={{
              border: "none",
              padding: "3px 8px",
              backgroundColor: "#007bff",
              fontWeight: "500",
              color: "#fff",
              borderRadius: "3px",
              fontSize: "0.85em",
              marginRight: "5px",
            }}
            onClick={() => handleAssign(banner)}
            size="small"
          >
            <AssignmentIcon style={{ fontSize: "14px", marginRight: "3px" }} />
            Asignar
          </button>
        ) : null}

        <button
            style={{
              border: "none",
              padding: "3px 8px",
              backgroundColor: "#dc3545",
              fontWeight: "500",
              color: "#fff",
              borderRadius: "3px",
              fontSize: "0.85em",
            }}
            onClick={() => handleDelete(banner)}
            size="small"
          >
            <DeleteIcon style={{ fontSize: "14px", marginRight: "3px" }} />
            Eliminar
          </button>

      </div>
    );
  };

  const handleEdit = (banner) => {
    setEditingBanner(banner);
  };

  const clearEdit = () => {
    setEditingBanner(null);
  };

  const handleBannerUpdated = () => {
    setEditingBanner(null);
    onBannerUpdate();
  };

  const handleDelete = async (banner) => {
    const result = await swal({
      title: "¿Estás seguro?",
      text: `¿Quieres eliminar el banner "${banner.titulo}"? Esta acción no se puede deshacer.`,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    });

    if (result) {
      try {
        const fd = new FormData();
        fd.append("idBanners", banner.idBanners);

        const res = await fetch(`${GENERAL_URL_API}/arte/eliminarBanner.php`, {
          method: "POST",
          credentials: 'include',
          body: fd,
        });

        const data = await res.json();
        if (data.status === 1) {
          swal("Banner eliminado exitosamente!", {
            icon: "success",
          });
          onBannerUpdate();
        } else {
          swal("Error", "No se pudo eliminar el banner", "error");
        }
      } catch (error) {
        console.error(error);
        swal("Error", "Ocurrió un error al eliminar el banner", "error");
      }
    }
  };

  const handleAssign = (banner) => {
    setAssigningBanner(banner);
  };

  const clearAssign = () => {
    setAssigningBanner(null);
  };

  const handleAssignmentCompleted = () => {
    setAssigningBanner(null);
    onBannerUpdate();
  };

  useEffect(() => {
    if (banners && banners.length > 0) {
      const tempColumns = [...columnDefinitions];
      const tempRows = banners.map((banner) => ({
        ...banner,
        estado: (
          <span
            className={`badge ${
              banner.estado === 1 ? "badge-success" : "badge-secondary"
            }`}
          >
            {banner.estado === 1 ? "Activo" : "Inactivo"}
          </span>
        ),
        acciones: renderActionButtons(banner),
      }));

      setColumns(tempColumns);
      setRows(tempRows);
    } else {
      setColumns([...columnDefinitions]);
      setRows([]);
    }
  }, [banners]);

  const changeColumnStatus = (columnField) => {
    const temp = [...columns];
    const index = temp.findIndex((column) => column.field === columnField);
    if (index !== -1) {
      temp[index].isVisible = !temp[index].isVisible;
      setColumns(temp);
    }
  };

  const isNumber = (n) => !isNaN(parseFloat(n)) && isFinite(n);

  const getExcelRows = () => {
    const temp = [...rows];
    // Procesar datos para Excel (remover componentes React)
    return temp.map(row => ({
      ...row,
      estado: row.activo === "1" ? "Activo" : "Inactivo",
      acciones: "Ver en aplicación"
    }));
  };

  if (loading) {
    return (
      <>
        <Skeleton animation="wave" />
        <Skeleton animation="wave" />
        <Skeleton animation="wave" />
        <Skeleton animation="wave" />
      </>
    );
  }

  // Si está editando un banner, mostrar el formulario de edición
  if (editingBanner) {
    return (
      <>
        <div className="d-flex align-items-center mb-3">
          <Button
            variant="outlined"
            onClick={clearEdit}
            style={{ marginRight: "10px" }}
          >
            ← Volver a la lista
          </Button>
          <h5 className="mb-0">Editar Banner: {editingBanner.titulo}</h5>
        </div>
        <CrearBannerIndividual
          banner={editingBanner}
          clearEdit={clearEdit}
          onBannerCreated={handleBannerUpdated}
        />
      </>
    );
  }

  // Si está asignando un banner, mostrar el formulario de asignación
  if (assigningBanner) {
    return (
      <AsignarBanner
        banner={assigningBanner}
        onVolver={clearAssign}
        onBannerUpdate={onBannerUpdate}
      />
    );
  }

  // Contar banners globales activos
  const bannersGlobalesActivos = banners ? banners.filter(banner => 
    (banner.activo === 1 || banner.activo === "1") && 
    banner.alcance && banner.alcance.includes("Global")
  ).length : 0;

  const mostrarAvisoPrecaucion = bannersGlobalesActivos < 4;

  return (
    <>
      <div className="admin-muted-text-small mt-1 mb-2">
        Gestiona los banners del sistema. Puedes editar, activar/desactivar, eliminar o asignar banners según su alcance.
      </div>

      {mostrarAvisoPrecaucion && (
        <div className="alert alert-warning mb-4" role="alert">
          <div className="d-flex align-items-center">
            <i className="fa fa-exclamation-triangle mr-2" style={{ fontSize: "16px" }}></i>
            <div>
              <strong>¡Precaución!</strong> Solo hay {bannersGlobalesActivos} banner(es) global(es) activo(s). 
              Se recomienda tener al menos 4 banners globales activos para una mejor experiencia de usuario.
            </div>
          </div>
        </div>
      )}

      {rows.length > 0 && (
        <>
          <TableColumnDropdown
            columns={columns}
            changeColumnStatus={changeColumnStatus}
          />
          <br />
          <ButtonGroup size="small" variant="contained" className="my-3">
            <CustomGreenButton
              onClick={() => {
                const dat = [...rows];
                navigator.clipboard
                  .writeText(JSON.stringify(dat))
                  .then(async () => {
                    await swal({
                      title: "Se ha copiado la tabla!",
                      icon: "success",
                    });
                  });
              }}
            >
              Copy
            </CustomGreenButton>
            <CustomGreenButton
              onClick={() => {
                exportFromJSON({
                  data: getExcelRows(),
                  fileName: "banners-gestion",
                  exportType: exportFromJSON.types.csv,
                });
              }}
            >
              CSV
            </CustomGreenButton>
            <CustomGreenButton
              onClick={() => {
                exportFromJSON({
                  data: getExcelRows(),
                  fileName: "banners-gestion",
                  exportType: exportFromJSON.types.json,
                });
              }}
            >
              JSON
            </CustomGreenButton>
            <CustomGreenButton>
              <ExcelWorkBook
                columns={[...columns].slice(0, -1)} // Excluir columna de acciones
                rows={getExcelRows()}
                filename={"banners-gestion"}
              />
            </CustomGreenButton>
          </ButtonGroup>
        </>
      )}

      <MDBDataTable
        small
        responsive
        striped
        searchTop
        searchBottom={false}
        pagingTop
        bordered
        data={{
          columns: columns.filter((obj) => obj.isVisible),
          rows: rows,
        }}
        noBottomColumns
        entriesOptions={[5, 10, 20, 50]}
        entriesLabel="Numero de filas"
        searchLabel="Buscar"
        paginationLabel={["Anterior", "Siguiente"]}
        infoLabel={["Mostrando", "a", "de", "entradas"]}
      />
    </>
  );
};

export default BannersTable; 